import { useCallback, useState } from 'react';
import { getLocally, storeLocally } from 'src/core/utils/StorageAPI';

/**
 * Per-browser dismiss for the Aspen nav "Solink Agents" promo.
 *
 * Deliberately un-prefixed so `StorageAPI.clearNonPersistent()` clears it on
 * logout and impersonation — a different user on the same browser should see
 * the ad again.
 */
export const AGENTS_PROMO_DISMISSED_KEY = 'solink-nav-agents-promo-dismissed';

function readDismissed(): boolean {
  return getLocally<boolean>(AGENTS_PROMO_DISMISSED_KEY) === true;
}

export function useAgentsPromoDismissed(): {
  dismissed: boolean;
  dismiss: () => void;
} {
  const [dismissed, setDismissed] = useState(readDismissed);

  const dismiss = useCallback(() => {
    storeLocally(AGENTS_PROMO_DISMISSED_KEY, true);
    setDismissed(true);
  }, []);

  return { dismissed, dismiss };
}

/** Visibility gate for the Solink Agents promo card. */
export function shouldShowAgentsPromo({
  hasAgentsTab,
  dismissed,
  isOnAgentsPage,
}: {
  hasAgentsTab: boolean;
  dismissed: boolean;
  isOnAgentsPage: boolean;
}): boolean {
  return hasAgentsTab && !dismissed && !isOnAgentsPage;
}
